import { render, staticRenderFns } from "./old_purchase_order.vue?vue&type=template&id=1edf0722&"
import script from "./old_purchase_order.vue?vue&type=script&lang=js&"
export * from "./old_purchase_order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports